document.addEventListener('DOMContentLoaded', () => {
  function initExclusiveAccordion() {
  document.querySelectorAll("details").forEach((detail) => {
    detail.addEventListener("toggle", function () {
      if (detail.open) {
        document.querySelectorAll("details").forEach((otherDetail) => {
          if (otherDetail !== detail) {
            otherDetail.removeAttribute("open");
          }
        });
      }
    });
  });
}
initExclusiveAccordion();

function initPriceSlider() {
  const rangeMin = document.getElementById('priceRangeMin');
  if(rangeMin){
  
  const rangeMax = document.getElementById('priceRangeMax');
  const outputMin = document.getElementById('priceMinOutput');
  const outputMax = document.getElementById('priceMaxOutput');
  const hiddenMin = document.getElementById('HiddenPriceMin');
  const hiddenMax = document.getElementById('HiddenPriceMax');
  const sliderRange = document.getElementById('sliderRange');
  const outputMinWrapper = document.getElementById('priceMinOutputWrapper');
const outputMaxWrapper = document.getElementById('priceMaxOutputWrapper');
  const clearBtn = document.getElementById('clear_price_range');
  const selected_result = document.getElementById('range_filter_selected_result');

  const minGap = 1;
  const sliderMinValue = parseInt(rangeMin.min);
  const sliderMaxValue = parseInt(rangeMin.max);

  function updateSlider(event) {
    let minVal = parseInt(rangeMin.value);
    let maxVal = parseInt(rangeMax.value);

    if (maxVal - minVal <= minGap) {
      if (event && event.target === rangeMin) {
        rangeMin.value = maxVal - minGap;
        minVal = parseInt(rangeMin.value);
      } else {
        rangeMax.value = minVal + minGap;
        maxVal = parseInt(rangeMax.value);
      }
    }

    outputMin.textContent = minVal;
    outputMax.textContent = maxVal;
    hiddenMin.value = minVal;
    hiddenMax.value = maxVal;

    const minPercent = (minVal / sliderMaxValue) * 100;
    const maxPercent = (maxVal / sliderMaxValue) * 100;
     outputMinWrapper.style.left = `calc(${minPercent}%)`;
    outputMinWrapper.style.transform = `translateX(calc(-${minPercent}%)`;
outputMaxWrapper.style.left = `calc(${maxPercent}%)`;
    outputMaxWrapper.style.transform = `translateX(calc(-${maxPercent}% + 10%))`;
    sliderRange.style.left = minPercent + "%";
    sliderRange.style.width = (maxPercent - minPercent) + "%";
    if (minVal !== sliderMinValue || maxVal !== sliderMaxValue) {
      hiddenMin.setAttribute("name", "filter.v.price.gte");
      hiddenMax.setAttribute("name", "filter.v.price.lte");
      clearBtn.classList.remove("clear_disable");
      selected_result.classList.remove("hidden");
    } else {
      hiddenMin.removeAttribute("name");
      hiddenMax.removeAttribute("name");
      clearBtn.classList.add("clear_disable");
      selected_result.classList.add("hidden");
    }
  }

  rangeMin.addEventListener("input", updateSlider);
  rangeMax.addEventListener("input", updateSlider);

  if (clearBtn) {
    clearBtn.addEventListener("click", function () {
      rangeMin.value = sliderMinValue;
      rangeMax.value = sliderMaxValue;
      updateSlider();
      applyFilters();
    });
  }

  updateSlider();
  }
}
  initPriceSlider();
const filterToggleBtn = document.querySelector('.filter-toggle-btn');
const filtersSidebar = document.getElementById('filtersSidebar');
const filtersOverlay = document.getElementById('filtersOverlay');
const filtersCloseBtns = document.querySelectorAll('.filters-close-btn');

function closeFilters() {
  if (filtersSidebar) filtersSidebar.classList.remove('open');
  if (filtersOverlay) filtersOverlay.classList.remove('active');
  document.body.classList.remove('filter_drawer-open');
}

if (filterToggleBtn && filtersSidebar && filtersOverlay) {
  filterToggleBtn.addEventListener('click', () => {
    filtersSidebar.classList.add('open');
    filtersOverlay.classList.add('active');
    document.body.classList.add('filter_drawer-open');
  });
}

if (filtersCloseBtns.length > 0) {
  filtersCloseBtns.forEach(button => {
    button.addEventListener('click', closeFilters);
  });
}

if (filtersOverlay) {
  filtersOverlay.addEventListener('click', closeFilters);
}


function closeFilters() {
  document.getElementById('filtersSidebar').classList.remove('open');
  document.getElementById('filtersOverlay').classList.remove('active');
  document.body.classList.remove('filter_drawer-open');
}

const productGrid = document.querySelector('.nplp-collection-grid');
const loader = document.getElementById('global-loader');
let currentPage = 1;
let isLoading = false;
let maxPages = 0;
let activeSearchParams = '';
let onScroll = null;

function setupInfiniteScroll() {
  if (!productGrid) {
    console.warn('productGrid not found.');
    return;
  }

  maxPages = parseInt(productGrid.dataset.maxPages, 10) || 0;

  if (onScroll) {
    window.removeEventListener('scroll', onScroll);
  }

  onScroll = () => {
    if (isLoading || currentPage >= maxPages) return;

    if (productGrid.getBoundingClientRect().bottom <= window.innerHeight + 200) {
      isLoading = true;
      currentPage++;

      fetch(`${window.location.pathname}?section_id=plp-2025-main-collection-product-grid&page=${currentPage}&${activeSearchParams}`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newGrid = doc.querySelector('.nplp-collection-grid');

          if (!newGrid || !newGrid.hasChildNodes()) {
            window.removeEventListener('scroll', onScroll);
            loader.style.display = 'none';
            return;
          }

          newGrid.childNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              productGrid.appendChild(node);

              if (node.classList.contains('nplp-product-card')) {
                try {
                  initializeProductCard(node);
                } catch (err) {
                  console.warn('Failed to initialize product card:', node, err);
                }
              }
            }
          });
rerenderShopLookSidebar();
          maxPages = parseInt(newGrid.dataset.maxPages, 10) || maxPages;
        })
        .catch(console.error)
        .finally(() => {
          isLoading = false;
        });
    }
};


  window.addEventListener('scroll', onScroll);
}
function rerenderShopLookSidebar() {
const sidebar = document.getElementById('slpShopLookSidebar');
  const overlay = document.getElementById('slpShopLookSidebarOverlay');
  const closeBtn = document.getElementById('slpShopLookSidebarClose');
  const tabsWrapper = document.getElementById('slpShopLookSidebarTabs');
  const contentWrapper = document.getElementById('slpShopLookSidebarContent');

  const selectedVariantIds = new Set();

  function extractId(gid) {
    return gid.split('/').pop();
  }
  function updatePriceElement(priceElement, rawPrice, currencyCode = 'USD', { hasSkuDiscount = false } = {}) {
  const original = Number(rawPrice).toFixed(2);

  if (window.sitewideDiscountEnabled && window.sitewideDiscountPercentage > 0) {
    const discountMultiplier = (100 - window.sitewideDiscountPercentage) / 100;
    const discounted = (original * discountMultiplier).toFixed(2);

    priceElement.innerHTML = `
      <span class="look-product-price-original-slashthrough">${formatShopifyPrice(original, currencyCode)}</span>
      <span class="look-product-price-discounted">${formatShopifyPrice(discounted, currencyCode)}</span>
      <span class="look-discount-badge" style="color:${window.sitewideBadgeTextColor}; background:${window.sitewideBadgeBgColor};">
        ${window.sitewideDiscountPercentage}% OFF
      </span>
    `;
  } else if (window.skuDiscountEnabled && window.skuDiscountPercentage > 0 && hasSkuDiscount) {
    const discountMultiplier = (100 - window.skuDiscountPercentage) / 100;
    const discounted = (original * discountMultiplier).toFixed(2);

    priceElement.innerHTML = `
      <span class="look-product-price-original-slashthrough">${formatShopifyPrice(original, currencyCode)}</span>
      <span class="look-product-price-discounted">${formatShopifyPrice(discounted, currencyCode)}</span>
      <span class="look-discount-badge" style="color:${window.skuBadgeTextColor}; background:${window.skuBadgeBgColor};">
        ${window.skuDiscountPercentage}% OFF
      </span>
    `;
  }
  else {
    priceElement.textContent = formatShopifyPrice(original, currencyCode);
  }
}
function formatShopifyPrice(amount, currencyCode = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0
  }).format(Number(amount));
}
  function applySitewideDiscount(price) {
  const numericPrice = Number(price);
  if (window.sitewideDiscountEnabled && window.sitewideDiscountPercentage > 0) {
    const discountMultiplier = (100 - window.sitewideDiscountPercentage) / 100;
    return (numericPrice * discountMultiplier).toFixed(2);
  }
  return numericPrice.toFixed(2);
}

  async function groupVariantsByProduct(variantGids) {
    const query = `{
      nodes(ids: [${variantGids.map(gid => `"${gid}"`).join(',')}]) {
        ... on ProductVariant {
          id
          title
          price {
            amount
            currencyCode
          }
          quantityAvailable
          availableForSale
          image {
            url
            altText
          }
          selectedOptions {
            name
            value
          }
          product {
            id
            title
            handle
            featuredImage {
              url
              altText
            }
            options {
              name
            }
            tags
          }
        }
      }
    }`;

    const response = await fetch('/api/2023-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '31e0c62958ffadf52f631843f44c7dc6',
      },
      body: JSON.stringify({ query }),
    });

    const result = await response.json();
    const grouped = {};

    result.data.nodes.forEach(variant => {
      if (!variant || !variant.product) return;

      const productId = variant.product.id;
      const sizeOpt = variant.selectedOptions.find(opt => opt.name.toLowerCase() === 'size');
      const materialOpt = variant.selectedOptions.find(opt => opt.name.toLowerCase() === 'material');
      const size = sizeOpt?.value || null;
      const material = materialOpt?.value || null;

      if (!grouped[productId]) {
        grouped[productId] = {
          product: {
            id: productId,
            title: variant.product.title,
            featuredImage: variant.product.featuredImage,
            tags: variant.product.tags || []
          },
          material: material,
          selectedVariants: [],
        };
      }

      if (variant.quantityAvailable > 0 || variant.availableForSale) {
        grouped[productId].selectedVariants.push({
          id: variant.id,
          title: variant.title,
          size: size,
          price: variant.price?.amount,
          currencyCode: variant.price?.currencyCode,
          quantityAvailable: variant.quantityAvailable,
          availableForSale: variant.availableForSale,
          featuredImage: variant.image || variant.product.featuredImage
        });
      }
    });

    return Object.values(grouped).filter(group => group.selectedVariants.length > 0);
  }

  async function fetchMetaobjectImage(gid) {
    const query = `{
      node(id: "${gid}") {
        ... on MediaImage {
          image {
            url
            altText
            height
            width
          }
        }
      }
    }`;

    const response = await fetch('/api/2023-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '31e0c62958ffadf52f631843f44c7dc6',
      },
      body: JSON.stringify({ query }),
    });

    const result = await response.json();
    return result?.data?.node?.image || null;
  }
  function renderLookUI(look, productGroups, container) {
    console.log('tab_data_target',container.id);
    const tab_data_target = container.id;
  const header_look_title = sidebar.querySelector('.slp-shop-look-sidebar-header-title');
  header_look_title.textContent = '';
  container.innerHTML = '';
    container.innerHTML = '';
    container.insertAdjacentHTML('beforeend', `
      <div class="slp-shop-look-tab-upper layout-not-expended">
        <div class="slp-shop-look-content-wrapper-tab">
          <div class="slp-shop-look-content-wrapper-tab-image">
            <button class="toggle-expand-layout">
              <svg class="expand-icon" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path d="M36 0.5C37.933 0.5 39.5 2.067 39.5 4V39.5H4C2.067 39.5 0.5 37.933 0.5 36V0.5H36Z" fill="white" stroke="#D9D9D8"/>
                <path d="M22.3077 10V11.5385H27.3738L11.5385 27.3738V22.3077H10V30H17.6923V28.4615H12.6262L28.4615 12.6262V17.6923H30V10H22.3077Z" fill="#43413E"/>
              </svg>
              <svg class="shrink-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M28 0.5C29.933 0.5 31.5 2.067 31.5 4V31.5H4C2.067 31.5 0.5 29.933 0.5 28V0.5H28Z" fill="white" stroke="#D9D9D8"/>
                <path d="M23.1701 8L17.165 14.0051V10.1613H15.9977V15.9977H21.8341V14.8304H17.9903L24 8.82075L23.1701 8ZM15.9977 15.9977H10.1613V17.165H14.0051L8 23.1701L8.82075 24L14.8304 17.9903V21.8341H15.9977V15.9977Z" fill="#43413E"/>
              </svg>
            </button>
          </div>
          <div class="slp-shop-look-product-added-count-tab">
            <div class="slp-shop-look-content-wrapper-tab-main-title"></div>
            <div class="slp-shop-look-product-added-count-tab-wrapper">
              <p class="slp-shop-look-product-added-count-message">Start with your favorite piece.</p>
              <span class="slp-shop-look-product-added-count-value"><span class="slp-shop-look-product-added-count-value-selected"></span> of <span class="slp-shop-look-product-added-count-value-totla"></span> added</span>
            </div>
          </div>
        </div>
        
        <div class="slp-shop-look-product-wrapper">
          <div class="slp-shop-look-product-card">
            <div class="slp-shop-look-product-card-image-wrapper"></div>
            <div class="slp-shop-look-product-card-content-wrapper"></div>
            <div class="slp-shop-look-product-card-btn-wrapper"></div>
          </div>
        </div>
      </div>
      <div class="slp-shop-look-tab-bottom">
        <div class="slp-shop-look-tab-product-total">
          <p class="slp-shop-look-tab-product-total-title">Subtotal:</p>
          <span class="slp-shop-look-tab-product-total-value">$--</span>
        </div>
        <div class="slp-shop-look-tab-addToCart-btns">
          <button class="slp-shop-look-tab-addToCart-btn-selected no_product" type="button" disabled>Add Your First Piece</button>
          <button class="slp-shop-look-tab-addToCart-btn-all" data-target="${tab_data_target}" type="button">Get the Full Look</button>
        </div>
      </div>
    `);
   const expandToggleBtn = container.querySelector('.toggle-expand-layout');
if (expandToggleBtn) {
  expandToggleBtn.addEventListener('click', () => {
    const parent = expandToggleBtn.closest('.layout-not-expended');
    if (!parent) return;

    if (parent.classList.contains('expand-look')) {
      parent.classList.add('expand-look-removing');
      setTimeout(() => {
        parent.classList.remove('expand-look');
      }, 200);
      setTimeout(() => {
        parent.classList.remove('expand-look-removing');
      }, 500);
    } else {
      parent.classList.add('expand-look');
    }
  });
}


    header_look_title.textContent = look.look_title || 'Look';
    const look_main_image = container.querySelector('.slp-shop-look-content-wrapper-tab-image');
    const look_main_title = container.querySelector('.slp-shop-look-content-wrapper-tab-main-title');
  if (look.look_image) {
    fetchMetaobjectImage(look.look_image).then(image => {
      if (image && image.url) {
        const lookImage = document.createElement('img');
        lookImage.src = image.url;
        lookImage.alt = image.altText || look.look_title || 'Look';
        lookImage.width = image.width || '';
        lookImage.height = image.height || '';
        look_main_image.append(lookImage);
        const subtitle = document.createElement('h3');
        subtitle.textContent = look.look_subtitle || '';
      
        const tagline = document.createElement('p');
        tagline.textContent = look.look_tagline || '';
        look_main_title.appendChild(subtitle);
        look_main_title.appendChild(tagline);
      } else {
        console.warn('No image returned for Metaobject look_image GID:', look.look_image);
      }
    }).catch(error => {
      console.error('Error fetching metaobject image:', error);
    });
  }

const productWrapper = container.querySelector('.slp-shop-look-product-wrapper');
productWrapper.innerHTML = '';

const selectedVariantIds = new Map();
const allProductVariantsState = [];

productGroups.forEach(group => {
  const hasSkuDiscount = (group.product.tags || []).some(
  t => String(t).toLowerCase() === 'sku-discount'
);
  const product = group.product;
  const selectedProductId = product.id;
  const firstVariant = group.selectedVariants[0];
  const defaultFormattedPrice = formatShopifyPrice(firstVariant.price, firstVariant.currencyCode);
if (!group.selectedVariants || group.selectedVariants.length === 0) return;

allProductVariantsState.push({
  productId: product.id,
  defaultVariantId: firstVariant.id,
  defaultPrice: Number(firstVariant.price),
  variantId: firstVariant.id,
  price: Number(firstVariant.price),
  hasSkuDiscount
});


  const productCard = document.createElement('div');
  productCard.classList.add('slp-shop-look-product-card');

  const imageWrapper = document.createElement('div');
  imageWrapper.classList.add('slp-shop-look-product-card-image-wrapper');
  const img = document.createElement('img');
  const variantImage = firstVariant.featuredImage || product.featuredImage;
img.src = variantImage?.url || '';
img.alt = variantImage?.altText || product.title;
  imageWrapper.appendChild(img);

  const contentWrapper = document.createElement('div');
  contentWrapper.classList.add('slp-shop-look-product-card-content-wrapper');

  const title = document.createElement('h5');
  title.textContent = product.title;
  contentWrapper.appendChild(title);

  if (group.material) {
    const material = document.createElement('p');
    material.classList.add('look-product-material');
    material.textContent = group.material;
    contentWrapper.appendChild(material);
  }

  const price = document.createElement('p');
price.classList.add('look-product-price');
const onlyId = firstVariant.id.split("/").pop();
price.setAttribute('data-variant-id', onlyId);
console.log('Setting price for variant ID:', onlyId);

updatePriceElement(price, firstVariant.price, firstVariant.currencyCode, { hasSkuDiscount });

contentWrapper.appendChild(price);


  const btnWrapper = document.createElement('div');
  btnWrapper.classList.add('slp-shop-look-product-card-btn-wrapper');

  const addBtn = document.createElement('button');
  addBtn.classList.add('look-add-btn');
  addBtn.innerHTML = `
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <rect width="28" height="28" rx="4" fill="#EFEEEC"/>
    <path d="M13.25 8V13.25H8V14.75H13.25V20.0001H14.75V14.75H20.0001V13.25H14.75V8H13.25Z" fill="#43413E"/>
  </svg>
`;

  const sizesWrapper = document.createElement('div');
  sizesWrapper.classList.add('look-product-sizes');
  sizesWrapper.innerHTML += `<p class="choose-option-label">Choose Size</p>`;
  sizesWrapper.classList.remove('show_grouped_sizes');

  if (group.selectedVariants.length > 1) {
    productCard.classList.add('shop-look-group-product');
    group.selectedVariants.forEach(variant => {
      if (!variant.size || variant.quantityAvailable === 0) return;

      const swatch = document.createElement('input');
      swatch.type = 'radio';
      swatch.name = `variant-${product.id}`;
      swatch.value = variant.id;
      swatch.id = `variant-${extractId(variant.id)}`;
      swatch.dataset.price = variant.price; 


      const label = document.createElement('span');
      label.textContent = variant.size;

      const swatchWrapper = document.createElement('label');
      swatchWrapper.classList.add('look-variant-swatch');
      swatchWrapper.htmlFor = swatch.id;
      swatchWrapper.appendChild(swatch);
      swatchWrapper.appendChild(label);
      sizesWrapper.appendChild(swatchWrapper);
    });

    if (sizesWrapper.children.length > 1) {
      addBtn.addEventListener('click', () => {
        if (addBtn.textContent === 'Added') {
          const vid = addBtn.dataset.variantId;
          selectedVariantIds.delete(vid);
          addBtn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
              <rect width="28" height="28" rx="4" fill="#EFEEEC"/>
              <path d="M13.25 8V13.25H8V14.75H13.25V20.0001H14.75V14.75H20.0001V13.25H14.75V8H13.25Z" fill="#43413E"/>
            </svg>
          `;
          addBtn.removeAttribute('data-variant-id');
          addBtn.classList.remove('selected_item');
          sizesWrapper.querySelectorAll('input[type="radio"]').forEach(i => (i.checked = false));
          updatePriceElement(price, selectedPrice, 'USD', { hasSkuDiscount });
          sizesWrapper.classList.remove('show_grouped_sizes');
        } else {
          sizesWrapper.classList.add('show_grouped_sizes');
        }
        updateLookSelectionUI();
      });

      sizesWrapper.addEventListener('change', e => {
        const selectedVariantId = e.target.value;
        const selectedPrice = e.target.dataset.price;

        selectedVariantIds.set(selectedVariantId, { 
      price: selectedPrice,
      productId: selectedProductId
      });
        addBtn.textContent = 'Added';
        addBtn.classList.add('selected_item');
        addBtn.dataset.variantId = selectedVariantId;
        updatePriceElement(price, selectedPrice, 'USD', { hasSkuDiscount });
        sizesWrapper.classList.remove('show_grouped_sizes');
        updateLookSelectionUI();

      });

      btnWrapper.appendChild(addBtn);
      btnWrapper.appendChild(sizesWrapper);
    } else {
      const onlyVariant = firstVariant;
      const formattedPrice = formatShopifyPrice(onlyVariant.price, onlyVariant.currencyCode);

      addBtn.addEventListener('click', () => {
        if (addBtn.textContent === 'Added') {
          selectedVariantIds.delete(onlyVariant.id);
          addBtn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
              <rect width="28" height="28" rx="4" fill="#EFEEEC"/>
              <path d="M13.25 8V13.25H8V14.75H13.25V20.0001H14.75V14.75H20.0001V13.25H14.75V8H13.25Z" fill="#43413E"/>
            </svg>
          `;
          addBtn.classList.remove('selected_item');
          updatePriceElement(price, firstVariant.price, firstVariant.currencyCode, { hasSkuDiscount });
        } else {
          selectedVariantIds.set(selectedVariantId, { 
          price: onlyVariant.price,
          productId: selectedProductId
          });
          addBtn.textContent = 'Added';
          addBtn.classList.add('selected_item');
          updatePriceElement(price, selectedPrice, 'USD', { hasSkuDiscount });
        }
        updateLookSelectionUI();
      });

      btnWrapper.appendChild(addBtn);
    }

  } else {
  const onlyVariant = firstVariant;

  if (!onlyVariant || onlyVariant.quantityAvailable === 0) return;

  const variantId = onlyVariant.id;
  const formattedPrice = formatShopifyPrice(onlyVariant.price, onlyVariant.currencyCode);

  addBtn.addEventListener('click', () => {
    if (addBtn.textContent === 'Added') {
      selectedVariantIds.delete(variantId);
      addBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <rect width="28" height="28" rx="4" fill="#EFEEEC"/>
        <path d="M13.25 8V13.25H8V14.75H13.25V20.0001H14.75V14.75H20.0001V13.25H14.75V8H13.25Z" fill="#43413E"/>
      </svg>
    `;
      addBtn.classList.remove('selected_item');
      updatePriceElement(price, firstVariant.price, firstVariant.currencyCode, { hasSkuDiscount });
    } else {
      selectedVariantIds.set(onlyVariant.id, {
  price: onlyVariant.price,
  productId: selectedProductId
});

      addBtn.textContent = 'Added';
      addBtn.classList.add('selected_item');
      updatePriceElement(price, onlyVariant.price, onlyVariant.currencyCode, { hasSkuDiscount });

    }
    updateLookSelectionUI();
  });

  btnWrapper.appendChild(addBtn);
}


  productCard.appendChild(imageWrapper);
  productCard.appendChild(contentWrapper);
  productCard.appendChild(btnWrapper);
  productWrapper.appendChild(productCard);

});

console.log('All Product Variants (default):', allProductVariantsState);
let totalAmount = 0;
allProductVariantsState.forEach(item => {
    const discounted = applySitewideDiscount(item.price);
  totalAmount += Number(discounted);
});

const tabBottom = container.querySelector('.slp-shop-look-tab-bottom');
if (tabBottom) {
  const fullLookBtn = tabBottom.querySelector('.slp-shop-look-tab-addToCart-btn-all');
  if (fullLookBtn) {
    const formattedTotal = formatShopifyPrice(totalAmount, 'USD');
    fullLookBtn.textContent = `Get the Full Look — ${formattedTotal}`;
  }
}

const selectedCountEl = container.querySelector('.slp-shop-look-product-added-count-value-selected');
const totalCountEl = container.querySelector('.slp-shop-look-product-added-count-value-totla');

if (selectedCountEl && totalCountEl) {
  selectedCountEl.textContent = selectedVariantIds.size;
  totalCountEl.textContent = allProductVariantsState.length;
}
updateLookSelectionUI();


function updateLookSelectionUI() {
  console.log('Selected Variant State (initial):', [...selectedVariantIds.entries()]);

  allProductVariantsState.forEach(item => {
    const selected = [...selectedVariantIds.entries()].find(
      ([variantId, { productId }]) => productId === item.productId
    );

    if (selected) {
      const [selectedVariantId, { price }] = selected;
      item.variantId = selectedVariantId;
      item.price = Number(price);
    } else {
      item.variantId = item.defaultVariantId;
      item.price = item.defaultPrice;
    }
  });

  console.log('All Product Variants (updated):', allProductVariantsState);

  const selectedCount = selectedVariantIds.size;
  const totalCount = allProductVariantsState.length;

  const selectedCountEl = container.querySelector('.slp-shop-look-product-added-count-value-selected');
  const totalCountEl = container.querySelector('.slp-shop-look-product-added-count-value-totla');
  const messageEl = container.querySelector('.slp-shop-look-product-added-count-message');
  const subtotalEl = container.querySelector('.slp-shop-look-tab-product-total-value');
  const selectedBtn = container.querySelector('.slp-shop-look-tab-addToCart-btn-selected');

  if (selectedCountEl && totalCountEl) {
    selectedCountEl.textContent = selectedCount;
    totalCountEl.textContent = totalCount;
  }

  if (messageEl) {
    if (selectedCount === 0) {
      messageEl.textContent = 'Start with your favorite piece.';
    } else if (selectedCount === totalCount) {
      messageEl.textContent = 'Look complete. Nailed it.';
    } else {
      messageEl.textContent = 'You’re building the look.';
    }
  }

  if (selectedBtn) {
    selectedBtn.classList.toggle('selectedBtn_hidden', selectedCount === totalCount);
    selectedBtn.classList.remove('no_product');
    selectedBtn.setAttribute('disabled','false');
    if (selectedCount === 0) {
      selectedBtn.textContent = 'Add Your First Piece';
      selectedBtn.classList.add('no_product');
      selectedBtn.setAttribute('disabled','true');
    } else {
      selectedBtn.textContent = `Add to Bag — ${selectedCount} Item${selectedCount > 1 ? 's' : ''} Selected`;
      selectedBtn.classList.remove('no_product');
      selectedBtn.removeAttribute('disabled','false');
    }
  }

if (subtotalEl) {
  if (selectedCount === 0) {
    subtotalEl.textContent = '$--';
  } else {
    let originalTotal = 0;
    let discountedTotal = 0;

    const hasSkuForProduct = (productId) => {
      const meta = allProductVariantsState.find(p => p.productId === productId);
      return !!meta?.hasSkuDiscount; // safe if undefined
    };

    const discountedUnit = (n, hasSku) => {
      const num = Number(n || 0);
      if (window.sitewideDiscountEnabled && window.sitewideDiscountPercentage > 0) {
        return +(num * (100 - window.sitewideDiscountPercentage) / 100).toFixed(2);
      }
      if (window.skuDiscountEnabled && window.skuDiscountPercentage > 0 && hasSku) {
        return +(num * (100 - window.skuDiscountPercentage) / 100).toFixed(2);
      }
      return +num.toFixed(2);
    };

    for (const { price, productId } of selectedVariantIds.values()) {
      const np = Number(price || 0);
      originalTotal += np;
      discountedTotal += discountedUnit(np, hasSkuForProduct(productId));
    }

    if (window.sitewideDiscountEnabled && window.sitewideDiscountPercentage > 0) {
      subtotalEl.innerHTML = `
        <span class="slp-shop-look-tab-product-total-value-compare">${formatShopifyPrice(originalTotal)}</span>
        ${formatShopifyPrice(discountedTotal)}
      `;
    } else if (window.skuDiscountEnabled && window.skuDiscountPercentage > 0 && discountedTotal !== originalTotal) {
      subtotalEl.innerHTML = `
        <span class="slp-shop-look-tab-product-total-value-compare">${formatShopifyPrice(originalTotal)}</span>
        ${formatShopifyPrice(discountedTotal)}
      `;
    } else {
      subtotalEl.textContent = formatShopifyPrice(originalTotal);
    }
  }
}


}
document.querySelectorAll('.slp-shop-look-tab-addToCart-btn-selected').forEach(btn => {
  btn.addEventListener('click', () => {
    const variantArray = [...selectedVariantIds.keys()];
    showCartLoader('Adding your picks to cart…');
    addToCartFromArray(variantArray);
  });
});

document.querySelectorAll('.slp-shop-look-tab-addToCart-btn-all').forEach(btn => {
  btn.addEventListener('click', () => {
    const tabId = btn.dataset.target;
    if (!tabId) return;
    const tabContainer = document.getElementById(tabId);
    if (!tabContainer) return;

    const tabWrapper = tabContainer.querySelector('.slp-shop-look-tab-upper');
    if (!tabWrapper) return;
    tabContainer.querySelector('.look-group-error')?.remove();
    tabWrapper.querySelectorAll('.slp-shop-look-product-card.shop-look-group-product .look-product-sizes')
      .forEach(sizeDiv => sizeDiv.classList.remove('show_grouped_sizes'));

    const groupProducts = tabWrapper.querySelectorAll('.slp-shop-look-product-card.shop-look-group-product');
    const hasUnselectedGroup = Array.from(groupProducts).some(productCard => {
      const addBtn = productCard.querySelector('.look-add-btn');
      return !addBtn?.classList.contains('selected_item');
    });
    if (hasUnselectedGroup) {
      tabContainer.dataset.waitingForGroupSelection = 'true';
      groupProducts.forEach(productCard => {
        const addBtn = productCard.querySelector('.look-add-btn');
        const sizeDiv = productCard.querySelector('.look-product-sizes');
        if (!addBtn?.classList.contains('selected_item')) {
          if (sizeDiv) sizeDiv.classList.add('show_grouped_sizes');
        }
      });
      const unselectedBtns = Array.from(tabWrapper.querySelectorAll('.look-add-btn'))
        .filter(b => !b.classList.contains('selected_item'));

      unselectedBtns.forEach((btnToClick, index) => {
        setTimeout(() => {
          btnToClick.click();
        }, 200 * index);
      });
      const errorMsg = document.createElement('div');
      errorMsg.className = 'look-group-error';
      
      errorMsg.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
        <circle cx="8" cy="9" r="7.5" stroke="#B50416"/>
        <path d="M8.62842 4.54545L8.53609 11.3409H7.46507L7.37274 4.54545H8.62842ZM8.00058 14.0739C7.77283 14.0739 7.5774 13.9923 7.41428 13.8292C7.25117 13.6661 7.16961 13.4706 7.16961 13.2429C7.16961 13.0152 7.25117 12.8197 7.41428 12.6566C7.5774 12.4935 7.77283 12.4119 8.00058 12.4119C8.22832 12.4119 8.42375 12.4935 8.58687 12.6566C8.74999 12.8197 8.83154 13.0152 8.83154 13.2429C8.83154 13.3937 8.79307 13.5322 8.71613 13.6584C8.64227 13.7846 8.54224 13.8861 8.41606 13.9631C8.29295 14.0369 8.15446 14.0739 8.00058 14.0739Z" fill="#B50416"/>
        </svg>
        Select your size to complete the look.
      `;

tabBottom.prepend(errorMsg);
      return;
    }
    const variantArray = allProductVariantsState.map(p => p.variantId);
    showCartLoader('Adding your full look to cart…');
    addToCartFromArray(variantArray);
  });
});
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'class' &&
      mutation.target.classList.contains('look-add-btn')
    ) {
      const btn = mutation.target;
      const tabWrapper = btn.closest('.slp-shop-look-tab-upper');
      if (!tabWrapper) return;

      const tabContainer = tabWrapper.closest('[data-waiting-for-group-selection="true"]');
      if (!tabContainer) return;

      const groupProducts = tabWrapper.querySelectorAll('.slp-shop-look-product-card.shop-look-group-product');
      const ungroupProducts = tabWrapper.querySelectorAll('.slp-shop-look-product-card:not(.shop-look-group-product)');

      const allGroupsSelected = Array.from(groupProducts).every(product => {
        const addBtn = product.querySelector('.look-add-btn');
        return addBtn?.classList.contains('selected_item');
      });

      if (allGroupsSelected) {
        const hasUnselectedUngroup = Array.from(ungroupProducts).some(product => {
          const addBtn = product.querySelector('.look-add-btn');
          return !addBtn?.classList.contains('selected_item');
        });
        delete tabContainer.dataset.waitingForGroupSelection;
        tabContainer.querySelector('.look-group-error')?.remove();

        if (!hasUnselectedUngroup) {
          const fullLookBtn = tabContainer.querySelector('.slp-shop-look-tab-addToCart-btn-all');
          if (fullLookBtn) {
            fullLookBtn.click();
          }
        }
      }
    }
  });
});
document.querySelectorAll('.look-add-btn').forEach(btn => {
  observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
});

const cartLoader = document.querySelector('.shop-look-loader-cart');
const cartProgress = cartLoader.querySelector('.cart-progress');
const cartProgressBar = cartLoader.querySelector('.cart-progress-bar');
const cartMessage = cartLoader.querySelector('p');
const scroll_div_cart = document.querySelector('.slp-shop-look-sidebar-panel');

function showCartLoader(message) {
  scroll_div_cart.scrollTop = 0;
  cartMessage.textContent = message;
  cartProgressBar.style.width = '0%';
  cartLoader.classList.add('visible');
  scroll_div_cart.classList.add('overflow-hidden');
}

  function hideCartLoader() {
  cartLoader.classList.remove('visible');
  scroll_div_cart.classList.remove('overflow-hidden');
}

function normalizeVariantId(variantId) {
  return variantId.includes('gid://') ? variantId.split('/').pop() : variantId;
}
function pushGA4AddToCartForVariants(variantIds) {
  // Normalize IDs (accept gid:// or plain)
  const ids = variantIds.map(id => id && id.toString().includes('gid://') ? id.split('/').pop() : String(id));
  const want = new Set(ids.map(n => Number(n)));

  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(r => r.json())
    .then(cart => {
      const currency = window.Shopify?.currency?.active || 'USD';
      const items = [];
      let value = 0;

      // Walk from newest to oldest so we pick the freshly added lines first
      for (let i = cart.items.length - 1; i >= 0; i--) {
        const li = cart.items[i];
        const vid = Number(li.variant_id);
        if (!want.has(vid)) continue;

        const unitPrice = Number(li.final_price ?? li.price ?? 0) / 100;
        items.push({
          item_id: String(vid),                                  // variant id (per your requirement)
          item_name: li.product_title || li.title || String(vid),
          price: +unitPrice.toFixed(2),
          quantity: 1,
          item_variant: li.variant_title || undefined
        });
        value += unitPrice;
        want.delete(vid);
      }

      // Any ids not found yet → include minimal objects (still valid GA4)
      want.forEach(missing => {
        items.push({
          item_id: String(missing),
          item_name: String(missing),
          quantity: 1
        });
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency,
          ...(items.length ? { value: +value.toFixed(2) } : {}),
          items
        }
      });
    })
    .catch(() => { /* no-op: don’t break UX if the push fails */ });
}

async function addToCartFromArray(variantArray) {
  const cartLoader = document.querySelector('.shop-look-loader-cart');
  const cartProgress = cartLoader?.querySelector('.cart-progress');
  const cartMessage = cartLoader?.querySelector('p');
  const overlay = document.querySelector('.slp-shop-look-sidebar-overlay');
  const sidebar_data_attributes = document.getElementById('slpShopLookSidebar');
  const sb_attr_data_section = sidebar_data_attributes.dataset.section;
  const sb_attr_data_page = sidebar_data_attributes.dataset.page;
  const sb_attr_data_widget = sidebar_data_attributes.dataset.widget;
  const sb_attr_data_experience = sidebar_data_attributes.dataset.experience;
  if (!cartLoader || !cartProgress || !cartMessage) return;

  const total = variantArray.length;
  let completed = 0;
  cartProgressBar.style.width = '0%';
  cartLoader.classList.add('active');

  try {
    for (const rawId of variantArray) {
      const id = rawId.includes('gid://') ? rawId.split('/').pop() : rawId;

      console.log('Adding variant ID:', id);

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id,
          quantity: 1,
          properties: {
            _section: sb_attr_data_section || '',
            _widget: sb_attr_data_widget || '',
            _experience: sb_attr_data_experience || '',
            _template: sb_attr_data_page || ''
          }
        })
      });

      if (!res.ok) {
        throw new Error(`Add to cart failed for ID: ${id}`);
      }

      completed++;
      const percent = Math.round((completed / total) * 100);
      cartProgressBar.style.width = `${percent}%`;
    }
    pushGA4AddToCartForVariants(variantArray);
    setTimeout(() => {
      overlay.click();
    }, 800);

  } catch (err) {
    console.error(err);
    cartMessage.textContent = 'Something went wrong. Please try again.';
    setTimeout(() => cartLoader.classList.remove('active'), 1500);
  }
}
}


 function openSidebar(metaobjects) {
  if (!metaobjects || !metaobjects.length) return;
   const body = document.querySelector('body');
   body.classList.add('overflow-hidden-looks');
  const loader = document.querySelector('.shop-look-loader');
  const scroll_div = document.querySelector('.slp-shop-look-sidebar-panel');
   const look_header_wrapper = document.querySelector('.slp-shop-look-sidebar-header');
  if (!loader) return;

  loader.classList.add('visible');
   scroll_div.classList.add('overflow-hidden');
  tabsWrapper.innerHTML = '';
  contentWrapper.innerHTML = '';
   console.log("Length of metaobjects:", metaobjects.length);
   if(metaobjects.length > 1){
     look_header_wrapper.classList.remove('hide_tab_btns');
   }else{
     look_header_wrapper.classList.add('hide_tab_btns');
   }
  metaobjects.forEach((obj, index) => {
    const tabId = `tab-${index}`;
    const title = `Look #${index + 1}`;

    const tabBtn = document.createElement('button');
    tabBtn.textContent = title;
    tabBtn.dataset.tab = tabId;
    if (index === 0) tabBtn.classList.add('active');
    tabsWrapper.appendChild(tabBtn);

    const contentDiv = document.createElement('div');
    contentDiv.id = tabId;
    contentDiv.className = index === 0 ? 'active' : '';
    contentDiv.innerHTML = '';
    contentWrapper.appendChild(contentDiv);

    tabBtn.addEventListener('click', () => {
      tabsWrapper.querySelectorAll('button').forEach(t => t.classList.remove('active'));
      contentWrapper.querySelectorAll('div').forEach(c => c.classList.remove('active'));

      tabBtn.classList.add('active');
      contentDiv.classList.add('active');

      renderSelectedLook(obj, contentDiv);
    });
  });

  sidebar.classList.add('is-visible');

  const firstLook = metaobjects[0];
  const firstContentDiv = contentWrapper.querySelector('#tab-0');
  renderSelectedLook(firstLook, firstContentDiv);
}
async function renderSelectedLook(look, container) {
  const loader = document.querySelector('.shop-look-loader');
  const scroll_div = document.querySelector('.slp-shop-look-sidebar-panel');
  if (!loader) return;

  loader.classList.add('visible');
  scroll_div.classList.add('overflow-hidden');
  container.innerHTML = ''; 
  container.classList.remove('active');

  try {
    const productGroups = await groupVariantsByProduct(look.look_product_variants || []);

    renderLookUI(look, productGroups, container);
    container.setAttribute('data-loaded', 'true');

    setTimeout(() => {
      loader.classList.remove('visible');
      scroll_div.classList.remove('overflow-hidden');
      container.classList.add('active');
    }, 1000); 

  } catch (e) {
    container.innerHTML = `<p>Error loading look</p>`;
    console.error('Look load error:', e);
    loader.style.display = 'none';
  }
}



  document.querySelectorAll('.slp-shop-looks-card-popup-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const blockId = btn.dataset.blockId || 'default';
      const data_section = btn.dataset.section || 'default';
      const sidebar_data_section = document.getElementById('slpShopLookSidebar');
      if (sidebar_data_section) {
  sidebar_data_section.setAttribute('data-section', data_section);
}
      const metaobjects = window.slpShopLookMetaobjects[blockId];
      openSidebar(metaobjects);
    });
  });
  document.querySelectorAll('.slp-shop-looks-card-image-popup-btn').forEach(div => {
  div.addEventListener('click', () => {
    const blockId = div.dataset.blockId || 'default';
    const data_section = btn.dataset.section || 'default';
      const sidebar_data_section = document.getElementById('slpShopLookSidebar');
      if (sidebar_data_section) {
  sidebar_data_section.setAttribute('data-section', data_section);
}
    const metaobjects = window.slpShopLookMetaobjects[blockId];
    openSidebar(metaobjects);
  });
});


  closeBtn.addEventListener('click', () => {
  sidebar.classList.remove('is-visible');
  const cart_loader_close = document.querySelector('.shop-look-loader-cart');
  const body = document.querySelector('body');
  body.classList.remove('overflow-hidden-looks');
    cart_loader_close.classList.remove('visible');
});

overlay.addEventListener('click', () => {
  sidebar.classList.remove('is-visible');
  const body = document.querySelector('body');
  body.classList.remove('overflow-hidden-looks');
  const cart_loader_close = document.querySelector('.shop-look-loader-cart');
  cart_loader_close.classList.remove('visible');
});
}

  if (productGrid) {
    document.querySelectorAll('.nplp-product-card').forEach(initializeProductCard);

    setupInfiniteScroll();
  } else {
    console.warn('productGrid not found on DOMContentLoaded');
  }

function addToCart(variantId, parentEl) {
  parentEl.classList.remove('sizes_active');
  parentEl.classList.add('active_bag_loader');

  const btn = parentEl.querySelector('.nplp-bag-icon');

  // ---- Loader handling (attach BEFORE the network calls) ----
  // The spinner used to be cleared only by a rebuy:cart.change listener
  // attached AFTER /cart/add.js and /cart.js had both resolved. Two ways
  // that leaves it spinning forever: Rebuy can fire before the listener
  // exists and {once:true} never sees a missed event, and where Rebuy is
  // absent or disabled the event never comes at all. Same shape as the fix
  // already in product-card.js.
  let loaderCleared = false;
  const clearLoader = () => {
    if (loaderCleared) return;
    loaderCleared = true;
    parentEl.classList.remove('active_bag_loader');
    document.removeEventListener('rebuy:cart.change', onRebuyChange);
    document.removeEventListener('rebuy:cart.add', onRebuyChange);
    clearTimeout(fallbackTimeout);
  };
  function onRebuyChange() { clearLoader(); }
  document.addEventListener('rebuy:cart.change', onRebuyChange, { once: true });
  document.addEventListener('rebuy:cart.add', onRebuyChange, { once: true });
  // Safety net for when Rebuy never fires (no widgets, app off, app error).
  const fallbackTimeout = setTimeout(clearLoader, 3000);
  // ---- End loader handling ----
  const payload = {
    items: [{
      id: Number(String(variantId).includes('gid://') ? String(variantId).split('/').pop() : variantId),
      quantity: 1,
      properties: {
        _section:    btn?.getAttribute('data-section')    || '',
        _widget:     btn?.getAttribute('data-widget')     || '',
        _experience: btn?.getAttribute('data-experience') || '',
        _template:   btn?.getAttribute('data-template')   || ''
      }
    }]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(payload)
  })
  .then(() => fetch('/cart.js', { headers: { 'Accept': 'application/json' }}))
  .then(r => r.json())
  .then(cart => {
    const vid = payload.items[0].id; // normalized numeric variant id
    const line = [...cart.items].reverse().find(i => Number(i.variant_id) === Number(vid));

    // --- push just these fields ---
    const qty       = 1;
    const currency  = window.Shopify?.currency?.active || 'USD';
    const name      = line?.product_title || line?.title || String(vid);
    const unitPrice = line ? +(Number(line.final_price ?? line.price ?? 0) / 100).toFixed(2) : undefined;
    const variant   = line?.variant_title || undefined;
    const value     = unitPrice != null ? +(unitPrice * qty).toFixed(2) : undefined;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency,
        ...(value != null ? { value } : {}),
        items: [{
          item_id:   String(vid),     // variant id (as requested)
          item_name: name,
          ...(unitPrice != null ? { price: unitPrice } : {}),
          quantity:  qty,
          ...(variant ? { item_variant: variant } : {})
        }]
      }
    });
    // -----------------------------

    // The add succeeded, so drop the spinner now rather than waiting on
    // Rebuy. clearLoader() is idempotent, so a later event is harmless.
    clearLoader();
  })
  .catch(err => {
    console.error('addToCart error:', err);
    clearLoader();
  });
}



  function initializeProductCard(card) {
    console.log('Initialize pro cards');
    const productId = card.dataset.productId;
    const variants = JSON.parse(card.querySelector('.product-variant-data').textContent);
    const materialInputs = card.querySelectorAll('.nplp-material-swatch input');
    const sizesDiv = card.querySelector('.nplp-size-swatches');
    const mainImage = card.querySelector('.product-main-image');
    const variantTitle = card.querySelector('.nplp-variant-title');
    const sizeParent = card.querySelector('.nplp-add-to-cart-wrapper');

    const renderSizes = (material) => {
  // existing
  const uniqueSizes = [...new Set(variants.map(v => v.option2))];
  sizesDiv.innerHTML = '';
  sizesDiv.innerHTML += `<p class="choose-option-label">Choose Size</p>`;

  if (uniqueSizes.length > 1) {
    sizeParent.classList.add('nplp-multiple-sizes');
  } else {
    sizeParent.classList.remove('nplp-multiple-sizes');
  }

  // Track if we actually rendered at least 1 usable swatch
  let renderedAny = false;

  uniqueSizes.forEach(sizeValue => {
    const matchingVariant = variants.find(v => v.option1 === material && v.option2 === sizeValue);
    const isAvailable = matchingVariant?.available;
    const variantId = matchingVariant?.id || '';

    // If no match or not available, you still render disabled in your original code.
    // We'll keep that behavior, but only mark renderedAny true if it has an id and is available.
    if (variantId && isAvailable) renderedAny = true;

    sizesDiv.innerHTML += `
      <label class="nplp-size-swatch ${(!matchingVariant || !isAvailable) ? 'disabled' : ''}">
        <input type="radio" name="size-${productId}" value="${sizeValue}"
          ${variantId ? `data-variant-id="${variantId}"` : ''}
          ${(!matchingVariant || !isAvailable) ? 'disabled' : ''}>
        <span>${sizeValue}</span>
      </label>
    `;
  });

  // ✅ NEW FALLBACK: if nothing usable was rendered, inject default variant as hidden swatch
  // Covers "Default Title" products (no real sizes) OR cases where material/size options don't exist
  if (!renderedAny) {
    const v = variants?.find(x => x?.available) || variants?.[0];
    const defaultId = v?.id;

    if (defaultId) {
      sizesDiv.innerHTML = `
        <label class="nplp-size-swatch" style="display:none;">
          <input type="radio"
                 name="size-${productId}"
                 value="Default"
                 data-variant-id="${defaultId}">
          <span>Default</span>
        </label>
      `;
      sizeParent.classList.remove('nplp-multiple-sizes');
    } else {
      console.warn('[renderSizes fallback] No default variant id found', { variants, productId });
    }
  }
};


    // Swap the rendered price pair for the chosen material. The markup comes
    // from a <template> that Liquid filled, one entry per material, so money
    // formatting matches the active market exactly -- Shopify.formatMoney is
    // not available here and prices vary per market.
    const pricePair = card.querySelector('.nplp-card-price-pair');
    const priceVariants = card.querySelector('.nplp-card-price-variants');

    const updatePrice = (material) => {
      if (!pricePair || !priceVariants) return;
      if (pricePair.dataset.material === material) return;
      const entry = [...priceVariants.content.children].find(
        el => el.dataset.material === material
      );
      if (!entry) return;   // leave the current price rather than blanking it
      pricePair.innerHTML = entry.innerHTML;
      pricePair.dataset.material = material;
    };

    const defaultMaterial = materialInputs[0]?.value;
    if (defaultMaterial) updatePrice(defaultMaterial);
    if (defaultMaterial) renderSizes(defaultMaterial);
    if (!defaultMaterial) renderSizes(variants?.[0]?.option1 || '');

    materialInputs.forEach(input => {
      input.addEventListener('change', () => {
        const selectedMaterial = input.value;
    
        // Convert to handle format
        const selectedMaterialHandle = selectedMaterial
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/(^-|-$)/g, '');
    
        console.log('selectedMaterial:', selectedMaterial);
        console.log('selectedMaterialHandle:', selectedMaterialHandle);
    
        variantTitle.textContent = selectedMaterial;
        renderSizes(selectedMaterial);
        updatePrice(selectedMaterial);
    
        const matchingVariant = variants.find(v => v.option1 === selectedMaterial);
        const splideElement = card.querySelector('.nplp-product-slider');
        const mainImg = splideElement?.querySelector('.product-main-image');
        const hoverImg = splideElement?.querySelector('.product-hover-image');
    
        const mainImageFullSrc = matchingVariant?.featured_image?.src
          ? 'https:' + matchingVariant.featured_image.src.split('?')[0]
          : '';
    
        if (mainImageFullSrc && mainImg) {
          mainImg.src = mainImageFullSrc;
          mainImg.alt = selectedMaterialHandle;
        }
    
        const imagesData = JSON.parse(card.querySelector('.product-all-images')?.textContent || '[]');
    
        const normalize = (url) => {
          try {
            return new URL(url, window.location.origin).pathname;
          } catch {
            return url?.split('?')[0] || '';
          }
        };
    
        const normalizedMainImage = normalize(mainImageFullSrc);
    
        let hoverImageData = imagesData.find(img => {
          const fullSrc = 'https:' + img.src;
          const normalizedHover = normalize(fullSrc);
          const matchesAlt = img.alt.includes(selectedMaterialHandle) && img.alt.includes('model');
          const isDifferent = normalizedHover !== normalizedMainImage;
    
          return matchesAlt && isDifferent;
        });
    
        if (!hoverImageData) {
          hoverImageData = imagesData.find(img => {
            const fullSrc = 'https:' + img.src;
            const normalizedHover = normalize(fullSrc);
            const matchesAlt = img.alt.includes(selectedMaterialHandle);
            const isDifferent = normalizedHover !== normalizedMainImage;
    
            return matchesAlt && isDifferent;
          });
        }
        if (hoverImg && hoverImageData) {
          hoverImg.src = 'https:' + hoverImageData.src;
          hoverImg.alt = hoverImageData.alt;
          console.log('Hover image updated:', hoverImageData.src);
        } else {
          console.warn('No matching hover image found; keeping existing hover image.');
        }
      });
    });

    card.querySelector('.nplp-bag-icon')?.addEventListener('click', e => {
      e.stopPropagation();
      const bagIcon = e.currentTarget;
      const parentEl = bagIcon.closest('.nplp-add-to-cart-wrapper');
      const visibleSizes = sizesDiv.querySelectorAll('.nplp-size-swatch');
      if (visibleSizes.length <= 1) {
        const singleVariant = visibleSizes[0]?.querySelector('input');
        if (singleVariant) addToCart(singleVariant.dataset.variantId, parentEl);
      } else {
        sizesDiv.classList.toggle('show');
        parentEl.classList.toggle('sizes_active');
        const handleOutsideClick = (event) => {
          if (!sizesDiv.contains(event.target) && !card.querySelector('.nplp-bag-icon').contains(event.target)) {
            sizesDiv.classList.remove('show');
            parentEl.classList.remove('sizes_active');
            document.removeEventListener('click', handleOutsideClick);
          }
        };
        if (sizesDiv.classList.contains('show')) {
          document.addEventListener('click', handleOutsideClick);
        }
      }
    });

    sizesDiv.addEventListener('change', e => {
      const variantId = e.target.dataset.variantId;
      const parentEl = sizesDiv.closest('.nplp-add-to-cart-wrapper');
      sizesDiv.classList.remove('show');
      if (variantId) addToCart(variantId, parentEl);
    });

    const splideElement = card.querySelector('.nplp-product-slider');
    const index = parseInt(splideElement.dataset.index, 10);
    function initializeResponsiveSlider(card, index) {
  const splideElement = card.querySelector('.nplp-product-slider');
  if (!splideElement) return;

  let splideInstance = null;

  const setupSplide = () => {
    const isMobile = window.innerWidth < 992;

    if (isMobile && !splideElement.classList.contains('is-mounted')) {
  splideInstance = new Splide(splideElement, {
    type: 'loop',
    perPage: 1,
    arrows: false,
    pagination: true,
    clones: 0,
    drag: true,
    swipeThreshold: 20,
    flickPower: 500,
  });

  splideInstance.mount();
  splideElement.classList.add('is-mounted');

  const slides = splideElement.querySelectorAll('.splide__slide');
  let firstSlideIndex = 0;
  slides.forEach((slide, idx) => {
    if (slide.classList.contains('first__slide')) {
      firstSlideIndex = idx;
    }
  });

  // Move to the first__slide
  splideInstance.go(firstSlideIndex);
}


    if (!isMobile && splideElement.classList.contains('is-mounted')) {
      splideInstance?.destroy();
      splideElement.classList.remove('is-mounted');
    }
  };

  setupSplide();
  window.addEventListener('resize', setupSplide);
}

    initializeResponsiveSlider(card, index);
  }

const filterForm = document.querySelector('#FacetFiltersForm');


  if (filterForm) {
    filterForm.addEventListener('change', (e) => {
      e.preventDefault();
      applyFilters();
    });
    function initializeResetButtons() {
  document.querySelectorAll('.facets__reset').forEach(button => {
    button.addEventListener('click', function () {
      const targetName = this.getAttribute('data-target');
      if (!targetName) return;

      const checkboxes = document.querySelectorAll(`input[type="checkbox"][name="${targetName}"]`);
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
      });

      applyFilters();
    });
  });
}
    initializeResetButtons();
    function initializeClearAllFilters() {
  const clearAllButtons = document.querySelectorAll('.clear_all_filter');
  if (!clearAllButtons.length) return;

  clearAllButtons.forEach(button => {
    button.addEventListener('click', function () {
      applyFilters(true);
    });
  });
}

initializeClearAllFilters();
function initializeActiveFilterRemoval() {
  document.querySelectorAll('.specific_filter_remove').forEach(pill => {
    pill.addEventListener('click', function (e) {
      e.preventDefault();
      const url = this.getAttribute('href');
      applyFiltersFromUrl(url);
    });
  });
}
initializeActiveFilterRemoval();
    function applyFilters(clearAll = false) {
  const openAccordions = [];

  document.querySelectorAll('.disclosure-has-popup').forEach(acc => {
    if (acc.open) {
      openAccordions.push(acc.getAttribute('data-filter-type'));
    }
  });

  const collectionUrl = window.location.pathname;
  let url, newUrl;

  if (clearAll) {
    url = `${collectionUrl}?section_id=plp-2025-main-collection-product-grid`;
    newUrl = `${collectionUrl}`;
    activeSearchParams = ''; 
  } else {
    const formData = new FormData(filterForm);
    activeSearchParams = new URLSearchParams(formData).toString();
    url = `${collectionUrl}?section_id=plp-2025-main-collection-product-grid&${activeSearchParams}`;
    newUrl = `${collectionUrl}?${activeSearchParams}`;
  }

  loader.style.display = 'flex';
  history.pushState({}, '', newUrl);

  fetch(url)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('.nplp-collection-grid');
      const newFacetForm = doc.querySelector('#FacetFiltersForm');

      productGrid.innerHTML = newGrid.innerHTML;
      filterForm.innerHTML = newFacetForm.innerHTML;

      productGrid.dataset.maxPages = newGrid.dataset.maxPages;
      maxPages = parseInt(newGrid.dataset.maxPages, 10);
      currentPage = 1;
      isLoading = false;

      openAccordions.forEach(type => {
        const acc = filterForm.querySelector(`.disclosure-has-popup[data-filter-type="${type}"]`);
        if (acc) acc.open = true;
      });

      document.querySelectorAll('.sidebar_close_btn').forEach(button => {
        button.addEventListener('click', closeFilters);
      });
      initExclusiveAccordion();
      initPriceSlider();
      initializeClearAllFilters();
      initializeResetButtons();
      initializeActiveFilterRemoval();
      document.querySelectorAll('.nplp-product-card').forEach(initializeProductCard);

      setupInfiniteScroll();
      window.scrollTo(0, 0);
    })
    .catch(console.error)
    .finally(() => {
      loader.style.display = 'none';
    });
}
    if (window.location.href.includes('filter')) {
  applyFilters();
}
function applyFiltersFromUrl(url) {
  const cleanUrl = new URL(url, window.location.origin);
  const fetchUrl = cleanUrl.pathname + '?section_id=plp-2025-main-collection-product-grid&' + cleanUrl.searchParams.toString();

  loader.style.display = 'flex';
  history.pushState({}, '', cleanUrl.pathname + '?' + cleanUrl.searchParams.toString());

  activeSearchParams = cleanUrl.searchParams.toString();

  fetch(fetchUrl)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('.nplp-collection-grid');
      const newFacetForm = doc.querySelector('#FacetFiltersForm');

      productGrid.innerHTML = newGrid.innerHTML;
      filterForm.innerHTML = newFacetForm.innerHTML;

      productGrid.dataset.maxPages = newGrid.dataset.maxPages;
      maxPages = parseInt(newGrid.dataset.maxPages, 10);
      currentPage = 1; 
      initExclusiveAccordion();
      initPriceSlider();
      initializeClearAllFilters();
      initializeResetButtons();
      initializeActiveFilterRemoval();
      document.querySelectorAll('.nplp-product-card').forEach(initializeProductCard);

      setupInfiniteScroll();

      window.scrollTo(0, 0);
    })
    .catch(console.error)
    .finally(() => {
      loader.style.display = 'none';
    });
}

  }
});